import { useEffect } from 'react';
import { useRouter } from '@abyss/web/hooks/useRouter';

export const ErrorRoute = () => {
  const {navigate} = useRouter();
  useEffect(() => {
      navigate('/error');
  });
  return null;
};